import React, { Fragment, useState, useEffect, useContext } from "react";
import { Container, Row, Col, Button, Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { BasicContext } from "../../../App";
import { BackOfficeContext } from "../BackOffice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUsers, faLayerGroup, faShapes, faPencilAlt, faPlus, faSpinner, faCircleNotch, faArrowsRotate } from "@fortawesome/free-solid-svg-icons";
import { postMethod } from "../../../requests";
import Search from "../../../components/inputs/Search";
import LoadedRecords from "../../../components/LoadedRecords";

const ClassesTemplates = () => {
    const { t } = useTranslation();
    const { checkServerData, NOR, changeView } = useContext(BasicContext);
    const { classesTemplates, setClassesTemplates } = useContext(BackOfficeContext);
    const [search, setSearch] = useState("");
    const [displayNOR, setDisplayNOR] = useState(NOR);
    const [list, setList] = useState(classesTemplates);
    const [loading, setLoading] = useState(true);

    const getClassesTemplatesList = async () => {
        const res = await postMethod("/classes-templates");
        if (checkServerData(res)) {
            setList(res.data.list);
            setClassesTemplates(res.data.list);
        }
    };

    const handleSearch = (v) => {
        const searchedPhrase = v.toLowerCase();
        setSearch(searchedPhrase);
        if (searchedPhrase !== "") {
            let filterThisList = classesTemplates;
            filterThisList = filterThisList.filter(
                (el) =>
                    el.class_name.toString().toLowerCase().includes(searchedPhrase) ||
                    el.class_level_name.toString().toLowerCase().includes(searchedPhrase) ||
                    el.class_type_name.toString().toLowerCase().includes(searchedPhrase) ||
                    el.instructor_name.toString().toLowerCase().includes(searchedPhrase) ||
                    el.instructor_surname.toString().toLowerCase().includes(searchedPhrase)
            );
            setList(filterThisList);
        } else {
            setList(classesTemplates);
        }
    };

    useEffect(() => {
        if (list) setLoading(false);
        // eslint-disable-next-line
    }, [list]);

    const handleSetContainerHeight = () => {};

    useEffect(() => {
        handleSetContainerHeight();
        window.removeEventListener("resize", handleSetContainerHeight);
        if (!classesTemplates) getClassesTemplatesList();

        // eslint-disable-next-line
    }, []);

    return (
        <Fragment>
            {loading ? (
                <Container>
                    <Row>
                        <Col className="my-5 text-center">
                            <p className="h4">
                                {t("loadingData")} <FontAwesomeIcon icon={faSpinner} className="ms-2 rotate-center" />
                            </p>
                        </Col>
                    </Row>
                </Container>
            ) : (
                <Fragment>
                    <Container fluid="lg">
                        <Row>
                            <Col xs={12} className="px-4 my-4 px-lg-2 ">
                                <h1 className="h4 d-inline-block m-0 pt-2">{t("templates.classesTemplates")}</h1>

                                <Button
                                    className="float-end d-inline-block ms-3"
                                    variant="outline-primary"
                                    onClick={() => changeView({ nav: "templates", sub: "addTemplate", params: { templateID: null } })}
                                >
                                    <FontAwesomeIcon icon={faPlus} className="me-lg-2" />
                                    <span className="d-none d-lg-inline">{t("templates.addTemplate")}</span>
                                </Button>
                                <Button
                                    className="float-end d-inline-block"
                                    variant="outline-secondary"
                                    onClick={() => {
                                        setLoading(true);
                                        getClassesTemplatesList();
                                    }}
                                >
                                    <FontAwesomeIcon icon={faArrowsRotate} />
                                </Button>
                            </Col>
                        </Row>
                        <Row className="sticky-top bg-light-primary">
                            <Col xs={12} lg={6} className="px-4 my-lg-4 mb-3 px-lg-2 ">
                                <Search value={search} onChange={(e) => handleSearch(e.target.value)} />
                            </Col>
                        </Row>
                        <Row>
                            {list.length > 0 ? (
                                <Fragment>
                                    <LoadedRecords displayNOR={displayNOR} list={list} />
                                    <Col xs={12} className="px-0 px-lg-2 ">
                                        <Table className="white-table">
                                            <tbody>
                                                {list
                                                    .map((e, i) => (
                                                        <Fragment key={i}>
                                                            <tr>
                                                                <td className="border-0 pb-0">
                                                                    <strong>{e.class_name}</strong>
                                                                </td>
                                                                <td className="border-0 text-end pb-0">
                                                                    {e.instructor_label ? e.instructor_label : `${e.instructor_name} ${e.instructor_surname}`}
                                                                </td>
                                                                <td className="text-center" rowSpan={3}>
                                                                    <Button
                                                                        variant="outline-secondary"
                                                                        className="btn-table-action"
                                                                        onClick={() =>
                                                                            changeView({ nav: "templates", sub: "editTemplate", params: { templateID: e.class_template_id } })
                                                                        }
                                                                    >
                                                                        <FontAwesomeIcon icon={faPencilAlt} />
                                                                    </Button>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td className="text-small border-0 pb-0">
                                                                    <FontAwesomeIcon icon={faLayerGroup} className="me-2 text-secondary" />
                                                                    {e.class_level_name}
                                                                </td>
                                                                <td className="text-end text-small border-0 pb-0">
                                                                    <FontAwesomeIcon icon={faUsers} className="me-2 text-secondary" />
                                                                    {e.class_slots}{" "}
                                                                    {e.class_slots === 1 ? t("1slot") : e.class_slots >= 2 && e.class_slots <= 4 ? t("2-4slots") : t("slots")}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td className="text-small">
                                                                    <FontAwesomeIcon icon={faShapes} className="me-2 text-secondary" />
                                                                    {e.class_type_name}
                                                                </td>
                                                                <td className="text-end text-small">
                                                                    <FontAwesomeIcon icon={faCircleNotch} className="me-2 text-secondary" />
                                                                    {e.class_template_active === "Y" ? t("active") : t("inactive")}
                                                                </td>
                                                            </tr>
                                                        </Fragment>
                                                    ))
                                                    .slice(0, displayNOR)}
                                            </tbody>
                                        </Table>
                                    </Col>
                                    <LoadedRecords displayNOR={displayNOR} list={list} />
                                    <Col xs={12} className="text-center">
                                        {displayNOR >= list.length ? (
                                            <p className="opacity-4  mb-3">
                                                <span className="px-3">{t("thatsAll")}</span>
                                            </p>
                                        ) : (
                                            <Button onClick={() => setDisplayNOR(NOR + displayNOR)} variant="outline-primary" className="mb-3">
                                                {t("loadMore")}
                                            </Button>
                                        )}
                                    </Col>
                                </Fragment>
                            ) : (
                                <Col xs={12} className="text-center">
                                    <p className="fs-5">{t("notFound")}</p>
                                </Col>
                            )}
                        </Row>
                    </Container>
                </Fragment>
            )}
        </Fragment>
    );
};

export default ClassesTemplates;
